<!--
 * @Description: 事件tab内容
 * @Date: 2022-03-08 13:59:54
 * @LastEditTime: 2023-05-23 16:09:15
-->
<template>
  <a-table
    :pagination="pagination"
    @change="handleTableChange"
    :columns="columns"
    :data-source="data"
  >
    <template #bodyCell="{ column, record }">
      <template v-if="column.key === 'outputs'">
        <a style="color: #5e66f2" @click.prevent="seePara(record, '出参')"> 查看 </a>
      </template>
    </template>
  </a-table>
  <div ref="modal2" class="modal-table-cover">
    <a-modal
      :width="640"
      okText="关闭"
      :getContainer="() => $refs.modal2"
      destroyOnClose
      v-model:visible="showPropModal"
      :title="propModalTitle"
      @ok="
        () => {
          showPropModal = false;
        }
      "
    >
      <PropTable :record="selectRecord" :type="propModalTitle" />
    </a-modal>
  </div>
</template>

<script>
import { defineComponent, ref, reactive } from "vue";
import PropTable from "@/components/model/model-definition/prop-table.vue";

const columns = [
  {
    title: "事件编码",
    dataIndex: "identifier",
    key: "identifier",
    ellipsis: true
  },
  {
    title: "事件名称",
    dataIndex: "name",
    key: "name",
    ellipsis: true
  },
  {
    title: "出参",
    dataIndex: "outputs",
    key: "outputs"
  }
];
export default defineComponent({
  components: { PropTable },
  props: {
    data: Array
  },
  setup(props) {
    //init
    let selectRecord = ref({});
    const pagination = reactive({
      showTotal: (total) => `共 ${total} 项数据`,
      current: 1,
      pageSize: 5,
      total: props.data.length
    });

    const handleTableChange = (info) => {
      pagination.current = info.current;
    };
    // 查看入参
    let propModalTitle = ref();
    let showPropModal = ref(false);
    const seePara = (record, type) => {
      propModalTitle.value = type;
      showPropModal.value = true;
      selectRecord.value = record;
    };
    return {
      columns,
      seePara,
      selectRecord,
      showPropModal,
      propModalTitle,
      handleTableChange,
      pagination
    };
  }
});
</script>
